import _typeof from "@babel/runtime/helpers/esm/typeof";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
import getFetchDefaultListOptions from '@nike/shop-apis/buy/wishlists/v2/fetch-default-list/get-options';
import { isBuyMarketplaceSupported } from '@nike/shop-apis/buy/supported-marketplaces';
import { addPageAction } from '@nike/ux-tread-new-relic';
import dispatchCustomEvent from "../../utils/dispatch-custom-event";
import createCustomEvent from "../../utils/create-custom-event";

/**
 * Initializes a user's wishlist by fetching the default list for the user or creating one for new users.
 *
 * @returns {Promise<Object>}
 */
var initializeWishlist = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _window$NikeShop;
    var queryClient, _defaultList$objects, _defaultList$objects2, _window$NikeShop2, _list, isLoggedIn, defaultList, list, _defaultList$objects$, _yield$import, getFetchListItemsOptions, defaultListId, _yield$import2, getCreateListOptions, _t;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          queryClient = (_window$NikeShop = window.NikeShop) === null || _window$NikeShop === void 0 || (_window$NikeShop = _window$NikeShop.__INTERNAL_USE__) === null || _window$NikeShop === void 0 ? void 0 : _window$NikeShop.queryClient;
          _context.prev = 1;
          _context.next = 2;
          return isBuyMarketplaceSupported();
        case 2:
          if (_context.sent) {
            _context.next = 3;
            break;
          }
          return _context.abrupt("return");
        case 3:
          _context.next = 4;
          return window.webShellClient.identity.getIsLoggedIn();
        case 4:
          isLoggedIn = _context.sent;
          _context.next = 5;
          return queryClient.fetchQuery(getFetchDefaultListOptions({
            isLoggedIn: isLoggedIn
          }));
        case 5:
          defaultList = _context.sent;
          addPageAction('nike-shop-wishlist-default-list-loaded', {
            defaultListObjectsLength: (_defaultList$objects = defaultList.objects) === null || _defaultList$objects === void 0 ? void 0 : _defaultList$objects.length
          });
          if (!(((_defaultList$objects2 = defaultList.objects) === null || _defaultList$objects2 === void 0 ? void 0 : _defaultList$objects2.length) > 0)) {
            _context.next = 8;
            break;
          }
          _context.next = 6;
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require('@nike/shop-apis/buy/wishlists/v2/lists/items/fetch-list-items/get-options'));
          });
        case 6:
          _yield$import = _context.sent;
          getFetchListItemsOptions = _yield$import["default"];
          defaultListId = (_defaultList$objects$ = defaultList.objects[0]) === null || _defaultList$objects$ === void 0 ? void 0 : _defaultList$objects$.id;
          _context.next = 7;
          return queryClient.fetchInfiniteQuery(getFetchListItemsOptions({
            id: defaultListId
          }));
        case 7:
          list = _context.sent;
          _context.next = 11;
          break;
        case 8:
          _context.next = 9;
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require('@nike/shop-apis/buy/wishlists/v2/create-list/get-options'));
          });
        case 9:
          _yield$import2 = _context.sent;
          getCreateListOptions = _yield$import2["default"];
          _context.next = 10;
          return queryClient.getMutationCache().build(queryClient, getCreateListOptions({
            queryClient: queryClient
          })).execute();
        case 10:
          list = _context.sent;
        case 11:
          dispatchCustomEvent(createCustomEvent((_window$NikeShop2 = window.NikeShop) === null || _window$NikeShop2 === void 0 || (_window$NikeShop2 = _window$NikeShop2.get()) === null || _window$NikeShop2 === void 0 || (_window$NikeShop2 = _window$NikeShop2.events) === null || _window$NikeShop2 === void 0 ? void 0 : _window$NikeShop2.listsInitialized, {
            bubbles: false,
            detail: {
              wishlistId: (_list = list) === null || _list === void 0 ? void 0 : _list.id
            }
          }));
          return _context.abrupt("return", list);
        case 12:
          _context.prev = 12;
          _t = _context["catch"](1);
          console.error('Error initializing wishlist:', _t); // eslint-disable-line no-console
          throw _t;
        case 13:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 12]]);
  }));
  return function initializeWishlist() {
    return _ref.apply(this, arguments);
  };
}();
export default initializeWishlist;